export default __webpack_public_path__ + "static/media/bg5.95ceafd9.jpg";